import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { exploresType } from "./exploreTypes";

import { Get_explore, Delete_explore } from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";

function ExploresComp() {
    const Navigate = useNavigate();
    let TableHead = ["BANNER", "CREATED ON", "STATUS", "ACTIONS"];
    const [explores, setexplores] = useState<exploresType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const getexplores = async () => {
        try {
            const response = await Get_explore();
            if (response?.data?.status === 1) {
                setexplores(response?.data?.data);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const Deleteexplore = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_explore(id);
            if (response?.data?.status === 1) {
                Toast("explore Deleted Successfully", "success");
                getexplores();
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        getexplores();
    }, []);

    // Function to handle image click and show the modal
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsModalVisible(true);
    };

    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    const deleteHandler = (item: exploresType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete explore?",
            () => Deleteexplore(item.exploreId),
            "Delete"
        );
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="explore"
            />
            <header>
                <h3>Explore</h3>
                {/* <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/explores/add")}>
                    <FiPlus />
                    Add explore
                </button> */}
            </header>
            {/*  <div className={Styles["filter"]}>
                <p>Filter By :</p>
                <select>
                    <option value="0">All</option>
                    <option value="1">Home explores</option>
                    <option value="2">Promotional explore</option>
                </select>
            </div> */}
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {explores.length > 0 ? (
                                explores?.map((item) => (
                                    <tr key={item?.exploreId}>
                                        <td
                                            onClick={() =>
                                                handleImageClick(item.image)
                                            }>
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.image}
                                                    alt="explore"
                                                />
                                            </div>
                                        </td>{" "}
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.created_at}
                                            </Moment>
                                        </td>
                                        <td>
                                            {item.status == 1 ? (
                                                <span
                                                    className={
                                                        Styles["Active"]
                                                    }>
                                                    Active
                                                </span>
                                            ) : (
                                                <span
                                                    className={
                                                        Styles["InActive"]
                                                    }>
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/explores/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                {/*    <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No explore Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default ExploresComp;
